import { faExclamationCircle } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components/macro";

export const AlertIcon = styled(FontAwesomeIcon).attrs({
  icon: faExclamationCircle,
})`
  color: ${({ theme }) => theme.colors.warning};
`;
